<template>
  <div class="footer clear">
    <div class="cw">
      Copyright (C) 2007 - 2021 THINKSKY CORPORATION. All Rights Reserved.
    </div>
  </div>
</template>
<script>
export default {
  setup() {},
};
</script>
